(function () {
  'use strict';

  function getDrawer() {
    return document.querySelector('#added-to-cart .inner');
  }

  // Grab ALL carousel instances; the app can render more than one
  function getAllUpsells() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-essential-upsell-element="products"]')
    ).filter(function (el) {
      return !el.closest('#added-to-cart'); // only ones not yet mounted
    });
  }

  // The upsell app renders its cards asynchronously (one after another).
  // We keep the block hidden until every slide has an image and a price,
  // then reveal it all at once.
  function isFullyLoaded(upsell) {
    var slides = upsell.querySelectorAll('[role="group"]');
    if (slides.length === 0) return false;
    return Array.prototype.every.call(slides, function (slide) {
      return (
        slide.querySelector('[data-essential-upsell-element="image"]') &&
        slide.querySelector('[data-essential-upsell-element="price"]')
      );
    });
  }

  function revealWhenReady(upsell) {
    if (upsell.classList.contains('upsell-ready')) return;

    upsell.classList.remove('upsell-ready');
    upsell.classList.add('upsell-loading');

    var check = setInterval(function () {
      if (isFullyLoaded(upsell)) {
        clearInterval(check);
        finish(true);
      }
    }, 100);

    // Safety: reveal whatever is real after 8s (app can take 5s+)
    var timeout = setTimeout(function () {
      clearInterval(check);
      finish(false);
    }, 8000);

    function finish(loaded) {
      clearInterval(check);
      clearTimeout(timeout);

      if (loaded) {
        // Fully loaded: hide skeletons and cap at 2 real products
        var slides = upsell.querySelectorAll('[role="group"]');
        var shown = 0;
        slides.forEach(function (s) {
          var real = s.querySelector('[data-essential-upsell-element="image"]') &&
                     s.querySelector('[data-essential-upsell-element="price"]');
          if (real && shown < 2) {
            shown++;
          } else {
            s.style.display = 'none';
          }
        });
      }
      // If timed out: reveal whatever is ready, hide nothing permanently

      upsell.classList.remove('upsell-loading');
      upsell.classList.add('upsell-ready');
    }
  }

  function injectTitle(drawer, links) {
    if (drawer.querySelector('.mini-cart-upsell-title')) return;

    var title = document.createElement('h4');
    title.className = 'mini-cart-upsell-title';
    title.textContent = 'Complete Your Routine'; // ← change wording here

    if (links) {
      links.insertAdjacentElement('afterend', title);
    } else {
      drawer.appendChild(title);
    }
  }

  function mountUpsell() {
    var drawer = getDrawer();
    if (!drawer) return;

    var upsells = getAllUpsells();
    if (upsells.length === 0) return;

    // Use the first instance; remove any duplicates
    var upsell = upsells[0];
    for (var i = 1; i < upsells.length; i++) {
      upsells[i].remove();
    }

    if (upsell.closest('#added-to-cart')) return;

    var links = drawer.querySelector('.links--no-checkout');

    // 1. Title (with spacing handled by CSS margins)
    injectTitle(drawer, links);

    // 2. Carousel — placed right after the title
    var title = drawer.querySelector('.mini-cart-upsell-title');
    if (title) {
      title.insertAdjacentElement('afterend', upsell);
    } else if (links) {
      links.insertAdjacentElement('afterend', upsell);
    } else {
      drawer.appendChild(upsell);
    }

    // 3. Reveal all products at once once loaded
    revealWhenReady(upsell);

    drawer.classList.add('has-upsell');
  }

  // Retries after add-to-cart clicks — the app renders the carousel
  // asynchronously after the AJAX cart response.
  document.body.addEventListener('click', function (e) {
    if (!e.target.closest('form[action*="/cart/add"] button, [data-action="add"], .product-form__cart-submit, button[type="submit"]')) return;

    [400, 1000, 2000, 3000].forEach(function (delay) {
      setTimeout(mountUpsell, delay);
    });
  }, true);

  // Watch for the drawer being revealed
  document.addEventListener('DOMContentLoaded', function () {
    var drawerRoot = document.getElementById('added-to-cart');
    if (drawerRoot) {
      new MutationObserver(function () {
        if (drawerRoot.classList.contains('reveal')) mountUpsell();
      }).observe(drawerRoot, { attributes: true, attributeFilter: ['class'], subtree: false });
    }
    mountUpsell(); // in case it's already open
  });
})();
